import React from "react";
import { FileDropzone } from "../../../shared/components";
import type { ScopeTypeOption } from "../../types";

interface WorkPatternImportDropzoneProps {
  onFileSelected: (file: File) => void;
  isProcessing: boolean;
  selectedFile?: File | null;
  /** When true, the dropzone is disabled regardless of processing state (e.g. company code not yet validated). */
  isDisabled?: boolean;
  /** Selected scope type — determines which scope-code column is shown in the hint. */
  scopeType: ScopeTypeOption | null;
}

const SCOPE_CODE_COLUMN: Record<ScopeTypeOption, string> = {
  Employee: "EmployeeCode",
  "Employee Group": "WorkPatternCode",
};

function buildSubInstruction(scopeType: ScopeTypeOption | null): string {
  const requiredColumns =
    "WorkPatternName, CycleDays, StartDate, PayPublicHolidays, StandardHours, StandardDays, Day1, Day2, ..., DayN";
  const scopeCodeCol = scopeType ? SCOPE_CODE_COLUMN[scopeType] : "WorkPatternCode";
  return `CSV must contain: ${requiredColumns}. ${scopeCodeCol} is optional (blank or absent values are sent as null).`;
}

export function WorkPatternImportDropzone({
  onFileSelected,
  isProcessing,
  selectedFile = null,
  isDisabled = false,
  scopeType,
}: WorkPatternImportDropzoneProps) {
  const handleFileChange = (files: File | File[] | null) => {
    if (files && !Array.isArray(files)) {
      onFileSelected(files);
    }
  };

  const csvFileFilter = (file: File) =>
    file.name.toLowerCase().endsWith(".csv");

  return (
    <FileDropzone
      value={selectedFile}
      compactWhenSelected
      onChange={handleFileChange}
      instruction="Drop CSV file here or click to upload"
      subInstruction={buildSubInstruction(scopeType)}
      accept=".csv"
      isDisabled={isDisabled || isProcessing}
      buttonText="Select CSV File"
      disabledButtonText={isDisabled && !isProcessing ? "Enter a company code first" : "Processing..."}
      fileFilter={csvFileFilter}
    />
  );
}
